import { Select, DatePicker, Button, Spin, message, Modal } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { changLgValue, convertToExcelEnd, getDataPost_2, showPolicyEnd } from "../../data/allfunction_2";

const dateFormat = "DD-MM-YYYY";
const { Option } = Select;
const ip = process.env.REACT_APP_IP;
const Export_Ecell_2_End = () => {
  const [sent_user_name, setsent_user_name] = useState("");
  const [sent_user, setsent_user] = useState();
  const [users, setUsers] = useState([]);
  const [sent_startCover, setsent_startCover] = useState();
  const [sent_endCover, setsent_endCover] = useState();
  const [confirm, setconfirm] = useState(true);
  const [loadding, setLoading] = useState(false);
  function onChange_timestart(value, dateString) {
    setsent_startCover(value);
  }
  function onChange_timeend(value, dateString) {
    setsent_endCover(value);
  }

  const userRedux = useSelector((state) => {
    return state.user;
  });
  const { value } = useSelector((state) => state.lg);
  function onchange_user(value) {
    try {
      let name = users.find((e) => e.id === value);
      setsent_user_name(name.name);
      setsent_user(value);
      setsent_user(name.user.substr(3));
    } catch (error) {
      setsent_user(0);
    }
  }
  const getUser = useCallback(async () => {
    let all = {
      id: 0,
      name: "ຕົວແທນທັງໝົ້ດ",
    };
    let link = `${ip}sell_online/users`;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    try {
      const response = await fetch(link, requestOptions);
      const result_1 = await response.json();
      if (result_1.status === 200) {
        if (userRedux.level === "manager" || userRedux.level === "acc") {
          let u = result_1.data;
          u.unshift(all);
          setUsers(u);
        } else {
          const uu = result_1.data.find((id) => id.id === userRedux.user_id);
          setUsers([uu]);
        }
      } else {
      }
    } catch (error) {
      return console.log("error", error);
    }
  }, [userRedux.level, userRedux.user_id]);

  useEffect(() => {
    getUser();
  }, [getUser]);
  useEffect(() => {
    if (
      sent_user === undefined ||
      sent_startCover === undefined ||
      sent_endCover === undefined
    ) {
      setconfirm(true);
    } else {
      setconfirm(false);
    }
  });
  return (
    <div>
      <Select
        // placeholder="ເລືອກຕົວແທນ"
        placeholder={changLgValue(value, 71)}
        optionFilterProp="children"
        style={{ width: "100%" }}
        onChange={onchange_user}
      >
        {users.map((value) => {
          return (
            <Option key={value.id} value={value.id}>
              {value.name} ({value.user})
            </Option>
          );
        })}
      </Select>
      <hr />
      <div className="d-flex flex-row">
        <div className="flex-fill">
          <div className="d-flex flex-row">
            <div className="mr-1 ml-1">
              {/* ເລີ່ມແຕ່ວັນທີ */}
              {changLgValue(value, 76)}
              ::</div>
            <div className="flex-fill mr-1 ml-1">
              <DatePicker
                // placeholder="ເລີ່ມແຕ່ວັນທີ"
                placeholder={changLgValue(value, 76)}
                style={{ width: "100%" }}
                //   showTime
                onChange={onChange_timestart}
                format={dateFormat}
              />
            </div>
          </div>
        </div>
        <div className="flex-fill">
          <div className="d-flex flex-row px-1">
            <div className="mr-1 ml-1">
              {/* ສິ້ນສຸດວັນທີ */}
              {changLgValue(value, 77)}
              ::</div>
            <div className="flex-fill mr-1 ml-1">
              <DatePicker
                style={{ width: "100%" }}
                // placeholder="ສິ້ນສຸດວັນທີ"
                placeholder={changLgValue(value, 77)}
                //   showTime
                onChange={onChange_timeend}
                format={dateFormat}
              />
            </div>
          </div>
        </div>
        <div className="flex-fill">
          <Button
            disabled={confirm}
            onClick={() => {
              getData();
            }}
            style={{ width: "100%" }}
            type="primary"
            loading={loadding}
          >
            {changLgValue(value, 78)}
            {/* ຄົ້ນຫາ{" "} */}
          </Button>
        </div>
      </div>
      {loadding && (
        <div className="example">
          <Spin tip="ກຳລັງດາວໂຫລດ..." size="large" />
        </div>
      )}
    </div>
  );
  // function getData_() {
  //   setLoading(true);
  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   var raw = JSON.stringify({
  //     start: sent_startCover,
  //     end: sent_endCover,
  //     agent: sent_user,
  //   });

  //   var requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };
  //   let link = `${ip}export_data/all`;
  //   fetch(link, requestOptions)
  //     .then((response) => {
  //       console.log(response.status);
  //       if (response.status != 200) {
  //         setLoading(false);
  //       }
  //       return response.blob();
  //     })
  //     .then((blob) => {
  //       // 2. Create blob link to download
  //       const url = window.URL.createObjectURL(new Blob([blob]));
  //       const link = document.createElement("a");
  //       link.href = url;

  //       link.setAttribute("download", `${userRedux.user}.xlsx`);
  //       // 3. Append to html page
  //       document.body.appendChild(link);
  //       // 4. Force download
  //       link.click();
  //       // 5. Clean up and remove the link
  //       link.parentNode.removeChild(link);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //       setLoading(false);
  //     });
  // }

  // function showPolicyEnd(data) {
  //   const groupedData = Object.values(
  //     data.reduce((acc, item) => {
  //       const key = item.policy_concat_no;

  //       if (!acc[key]) {
  //         acc[key] = {
  //           type: item.type,
  //           USER: item.USER,
  //           policy_concat_no: item.policy_concat_no,
  //           o_name: item.o_name,
  //           o_address: item.o_address,
  //           o_tel: item.o_tel,
  //           o_type: item.o_type,
  //           o_make: item.o_make,
  //           o_plate: item.o_plate,
  //           o_color: item.o_color,
  //           o_power: item.o_power,
  //           o_engine: item.o_engine,
  //           o_chassis: item.o_chassis,
  //           o_weight: item.o_weight,
  //           o_seats: item.o_seats,
  //           premuim: item.premuim,
  //           vat: item.vat,
  //           register: item.register,
  //           total_premuim: item.total_premuim,
  //           start: item.start,
  //           end: item.end,
  //           cover: item.cover,
  //           claim: []
  //         };
  //       }

  //       // เพิ่มข้อมูลเคลมเข้าไปใน array claim
  //       acc[key].claim.push({
  //         claim_id: item.claim_id,
  //         claim_info: item.claim_info,
  //         claim_address: item.claim_address,
  //         where_table: item.where_table,
  //         policy_no: item.policy_no,
  //         payment_orders: item.payment_orders
  //       });

  //       return acc;
  //     }, {})
  //   );
  //   return groupedData
  // }

  async function getData() {
    setLoading(true);
    try {
      let dataSetForGet = {
        start: moment(sent_startCover).format("YYYY-MM-DD") + " 00:00:00",
        end: moment(sent_endCover).format("YYYY-MM-DD") + " 23:59:59",
        agentCode: sent_user,
        selection: 0,
      };
      let l = ip + "sell_2_online/ReportPolicyOnline_end";
      let data = await getDataPost_2(
        l,
        dataSetForGet,
        userRedux.token,
        userRedux.retoken
      );
      console.log(`ອອນໄລ-ຈຳນວນສັນຍາ ${showPolicyEnd(data?.rows1 || [])?.length} ຈຳນວນຄະດີ ${(data?.rows1 || [])?.length}`);
      console.log(showPolicyEnd(data?.rows1 || []));
      console.log(`/`)
      console.log(`ແບບຂຽນ-ຈຳນວນສັນຍາ ${showPolicyEnd(data?.rows2 || [])?.length} ຈຳນວນຄະດີ ${(data?.rows2 || [])?.length}`);
      console.log(showPolicyEnd(data?.rows2 || []));


      // message.info(
      //   `ອອນໄລ-ຈຳນວນສັນຍາ ${showPolicyEnd(data?.rows1 || [])?.length} ຈຳນວນຄະດີ ${(data?.rows1 || [])?.length}
      //    \n/ \n
      //    ແບບຂຽນ-ຈຳນວນສັນຍາ ${showPolicyEnd(data?.rows2 || [])?.length} ຈຳນວນຄະດີ ${(data?.rows2 || [])?.length}`
      // );
      // alert(1000);

      Modal.info({
        title: "ຂໍ້ມູນ",
        content: (
          <div>
            {/* <p style={{ color: 'red' }}>
              ສັນຍາແບບອອນໄລ-ຈຳນວນສັນຍາ {showPolicyEnd(data?.rows1 || [])?.length} ສັນຍາ ຈຳນວນຄະດີ{" "}
              {(data?.rows1 || [])?.length}
            </p>
            <p style={{ color: 'red' }}>
              ສັນຍາແບບຂຽນ-ຈຳນວນສັນຍາ {showPolicyEnd(data?.rows2 || [])?.length} ຈຳນວນຄະດີ{" "}
              {(data?.rows2 || [])?.length}
            </p> */}

            <h5>ສັນຍາແບບອອນໄລ</h5>
            <p >
              ຈຳນວນສັນຍາ <span style={{ color: 'red' }}>{showPolicyEnd(data?.rows1 || [])?.length}</span> ສັນຍາ
            </p>

            <hr />
            <h5>ສັນຍາແບບຂຽນ</h5>
            <p >
              ຈຳນວນສັນຍາ <span style={{ color: 'red' }}> {showPolicyEnd(data?.rows2 || [])?.length} </span> ສັນຍາ
            </p>
          </div>
        ),
      });

      if (data != null) {
        convertToExcelEnd(
          showPolicyEnd([...data?.rows1, ...data?.rows2] || []),
          `ລາຍງານສັນຍາທີ່ຈະໝົ້ດອາຍຸລະຫວ່າງວັນທີ${moment(sent_startCover).format(
            dateFormat
          )}ຫາ${moment(sent_endCover).format(dateFormat)}`
        );



      } else {
        throw new Error(data);
      }
    } catch (error) {
      console.log(error)
      alert("ໂທກເຄັນທ່ານໝົ້ດອາຍຸ ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່");
    } finally {
      setLoading(false);
    }
  }

};


export default Export_Ecell_2_End;
